import { l as PRODUCT_TILE_ADD_TO_CART_START_EVENT, P as PRODUCT_TILE_ADD_TO_CART_SUCCESS_EVENT, m as PRODUCT_TILE_ADD_TO_CART_COMPLETE_EVENT, N as NON_FOLLOWED_TAG, o as PRODUCT_TILE_ADD_TO_CART_FAIL_EVENT } from './built-constants-439d5572.js';
import { a as addToCart } from './built-ajax-api-4ab76389.js';
import { c as cartEventEmitter } from './built-cart-event-emitter-def8079a.js';
import './built-config-a65ae98c.js';
import './built-loglevel-42c63e3e.js';
import { g as getCustomErrorMessage } from './built-error-message-utilities-4ca13134.js';

// @ts-check
/** @typedef { import('../../product-tile-atc').ProductTileAddToCartFormElement } ProductTileAddToCartFormElement */

/** @typedef { import('../../product-tile-atc').ProductTileAddToCartFormEvent } ProductTileAddToCartFormEvent */

/**
 * @typedef { Object } TileATCErrorPayload
 * @property { ProductTileAddToCartFormEvent } event
 * @property { string } message
 */

/**
 * @typedef { Object } TileATCSuccessPayload
 * @property { ProductTileAddToCartFormEvent } event
 * @property { Object } addedProduct
 * @property { CartItem[] } addedProduct.items
 */

/**
 * @typedef { Omit<import('mitt').Emitter, 'emit'> & {emit: (type: string, event?:ProductTileAddToCartFormEvent) => void } } ProductTileAddToCartFormDefaultEventEmitter
 */

/**
 * @typedef { Omit<import('mitt').Emitter, 'emit'> & {emit: (type: string, event?:TileATCSuccessPayload) => void } } ProductTileAddToCartFormSuccessEventEmitter
 */

/**
 * @typedef { Omit<import('mitt').Emitter, 'emit'> & {emit: (type: string, event?:TileATCErrorPayload) => void } } ProductTileAddToCartFormErrorEventEmitter
 */

/**
 * Handles adding item to cart, and emits events throughout. Will also call
 * callback function as the ATC state changes.
 *
 * @param { ProductTileAddToCartFormEvent } event
 * @param {{
 *  onPending: ({ event: ProductTileAddToCartFormEvent }) => void,
 *  onSuccess: ({ event: ProductTileAddToCartFormEvent }) => void,
 *  onError: ({ event: ProductTileAddToCartFormEvent, error: Error}) => void
 * }} [onStateCallbacks]
 */

const onAddToCart = async (event, {
  onPending,
  onSuccess,
  onError
}) => {
  const submitFormEl = event.target;

  try {
    var _submitFormEl$variant;

    event.preventDefault();
    event.stopPropagation();
    /** @type {ProductTileAddToCartFormDefaultEventEmitter} */

    cartEventEmitter.emit(PRODUCT_TILE_ADD_TO_CART_START_EVENT, event);
    onPending && onPending({
      event
    });
    const variantId = submitFormEl == null ? void 0 : (_submitFormEl$variant = submitFormEl.variantId) == null ? void 0 : _submitFormEl$variant.value;

    if (!variantId) {
      throw new Error('No product ID found on element');
    }

    const addedProduct = await addToCart([{
      quantity: 1,
      id: parseInt(variantId, 10)
    }]);

    if (!addedProduct) {
      throw new Error('Unable to add product to cart');
    }
    /** @type {ProductTileAddToCartFormSuccessEventEmitter} */


    cartEventEmitter.emit(PRODUCT_TILE_ADD_TO_CART_SUCCESS_EVENT, {
      event,
      addedProduct
    }); // @todo Consider whether we need to pass back the addedProduct in the callback

    onSuccess && onSuccess({
      event
    });
  } catch (error) {
    errorHandler({
      event,
      error
    });
    onError && onError({
      event,
      error
    });
  } finally {
    /** @type {ProductTileAddToCartFormDefaultEventEmitter} */
    cartEventEmitter.emit(PRODUCT_TILE_ADD_TO_CART_COMPLETE_EVENT, event);
  }
};
/**
 * Handles errors from cart add & emits failure
 * event
 *
 * @TODO finalize error handling, error message display
 * @param {Object} params
 * @param {Error} params.error
 * @param {ProductTileAddToCartFormEvent} params.event
 */

const errorHandler = ({
  error,
  event
}) => {
  var _event$target;

  // Non-followed products receive a different error message
  const isNonFollowed = ((_event$target = event.target) == null ? void 0 : _event$target.dataset.isNonFollowed) === 'true';
  const customMessage = getCustomErrorMessage(error.message, {
    tags: [isNonFollowed ? NON_FOLLOWED_TAG : '']
  });
  /** @type {ProductTileAddToCartFormErrorEventEmitter} */

  cartEventEmitter.emit(PRODUCT_TILE_ADD_TO_CART_FAIL_EVENT, {
    event,
    message: customMessage
  });
};

export { onAddToCart as o };
